import { Box, Group, Stack, useMantineTheme } from '@mantine/core';
import { Text } from '@repo/foundations';

export function TooltipContentRenderer({
	legendAndValuePairs,
	groupValue,
	columnAndValuePairs,
}: {
	groupValue?: string;
	legendAndValuePairs?: {
		valueFormatted: string;
		legend: {
			name: string;
			color: string;
			shortDisplayValue?: string | null;
		};
	}[];

	// For scatter chart
	columnAndValuePairs?: {
		columnFormattedName: string;
		formattedValue: string;
	}[];
}) {
	const theme = useMantineTheme();

	return (
		<Stack spacing="sm" p="sm">
			{groupValue && (
				<Text size="xs" weight="semibold" color="text/primary/default">
					{groupValue}
				</Text>
			)}
			<Stack spacing="xs">
				{legendAndValuePairs?.map(({ legend, valueFormatted }) => (
					<Group key={legend.name} noWrap position="apart">
						<Group spacing="xs" noWrap>
							<Box
								w={theme.other.space[2]}
								h={theme.other.space[2]}
								style={{
									borderRadius: theme.other.space[32],
									backgroundColor: legend.color,
								}}
							/>
							<Text size="xs" color="text/secondary/default">
								{legend.shortDisplayValue}
							</Text>
						</Group>
						<Text size="xs" weight="semibold" color="text/secondary/default">
							{valueFormatted}
						</Text>
					</Group>
				))}
				{columnAndValuePairs?.map(({ columnFormattedName, formattedValue }) => (
					<Group key={columnFormattedName} noWrap position="apart">
						<Text size="xs" color="text/secondary/default">
							{columnFormattedName}
						</Text>
						<Text size="xs" weight="semibold" color="text/secondary/default">
							{formattedValue}
						</Text>
					</Group>
				))}
			</Stack>
		</Stack>
	);
}
